import React from "react";
import { normaliseCurrency } from "../../../utils/eventRewards";

/**
 * Pick the currency a reward is paid in.
 *
 * A plain text box was technically enough — the API takes any symbol — but a
 * box pre-filled with "USDT" reads as a fixed label, so nobody discovers that a
 * prize can be BTC. The shortlist is one click; "Other" is still a free text
 * box for anything not on it.
 *
 * Which mode is showing is derived from the value rather than held in state, so
 * a row that arrives from the API already carrying an unusual symbol opens with
 * that symbol visible in the text box, not silently reset to the first option.
 */

const CUSTOM = "__custom__";

const CurrencySelect = ({
  value,
  onChange,
  onBlur,
  options,
  selectClassName = "",
  inputClassName = "",
  disabled = false,
}) => {
  const current = normaliseCurrency(value);
  const isListed = options.includes(current);

  return (
    <>
      <select
        value={isListed ? current : CUSTOM}
        onChange={(e) => onChange(e.target.value === CUSTOM ? "" : e.target.value)}
        onBlur={onBlur}
        disabled={disabled}
        className={selectClassName}
        title="Reward currency"
      >
        {options.map((currency) => (
          <option key={currency} value={currency}>
            {currency}
          </option>
        ))}
        <option value={CUSTOM}>Other…</option>
      </select>

      {!isListed && (
        <input
          type="text"
          value={value ?? ""}
          onChange={(e) => onChange(e.target.value.toUpperCase())}
          onBlur={onBlur}
          disabled={disabled}
          placeholder="SYMBOL"
          maxLength={16}
          autoFocus={current === ""}
          className={inputClassName}
          title="Any symbol the prize is paid in, e.g. SHIB"
        />
      )}
    </>
  );
};

export default CurrencySelect;
